<template>
<div>
      <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                        :value="myValue"
                        :options="theoptions"
                         @change="updateValue"
                        @input="inputValue"
                        text-field="name"
                        :disabled="disabled"
                        >
                        <option slot="first" :value="null">Escolha...</option>
                    </b-form-select>
</div>
</template>

<script>
export default {
   data(){
        return {myValue:null }
    },
    props:{
        options:{
            default:()=>[]
        },
        value:{},
        disabled:{
            type:Boolean,
            default:false
        }

    },
    created:function(){
        this.myValue = this.value
    },
    
    watch:{
        value:function(val){
            this.myValue = val
        }
    },
    
    computed:{
        theoptions:function(){
            if(_.isArray(this.options)){
                return this.options
            }else{
                return []
            }
        }
    },
    
    methods:{
         updateValue:function(val){
            this.myValue = val
            this.$emit('change',val)
            this.$emit('input',val)
        },
         inputValue:function(val){
            this.myValue = val
            this.$emit('input',val)
        },

    }
}
</script>

<style>

</style>
